<!-- large viewport -->
<div class="d-none d-lg-block">
  <div class="row statusHeader bg-light align-items-center">
    <div class="col-8">
      <!-- DISPLAY title + badge (WHEN short title) -->
      <h2 *ngIf="!displayAsTruncatedText(request.jobName)" class="status-title text-truncate">{{request.jobName}}
        <pillbadge-status-display [data]="statusBadge" [status]="statusIndicator" [iconTag]="''" [disable]="false"
          class="ms-2 text-start"></pillbadge-status-display>
      </h2>
      <!-- DISPLAY truncated title + badge (WHEN long title) -->
      <h2 *ngIf="displayAsTruncatedText(request.jobName)" class="status-title text-truncate"
        [ngbTooltip]="request.jobName">{{truncateTo(request.jobName)}} <pillbadge-status-display [data]="statusBadge"
          [status]="statusIndicator" [iconTag]="''" [disable]="false"
          class="ms-2 text-start"></pillbadge-status-display></h2>
    </div>
    <div class="col-4 text-end">
      <desktop-status-actions></desktop-status-actions>
    </div>
  </div>

  <div class="p-0">
    <hr class="hr" />
  </div>
</div>